'use strict';

var zustand = require('zustand');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactDom = require('react-dom');
var reactTransitionGroup = require('react-transition-group');
var translation = require('@templafy/translation');

const MAX_NOTIFICATION_BEFORE_QUEUE = 5;
const DEFAULT_NOTIFICATION_DURATION_MS = 10000;
const ANIMATION_TIMEOUT = 300;

require("./_assets/Icon-XoP2G5ML.css");var styles$1 = {"icon":"Icon__8ktaWFH4-c__icon"};

var IconColor;
(function (IconColor) {
    IconColor["Success"] = "color-success-600";
    IconColor["Primary"] = "color-primary-500";
    IconColor["Alert"] = "color-alert-600";
    IconColor["Danger"] = "color-danger-600";
})(IconColor || (IconColor = {}));
const gridSize = 24;
const IconContainer = ({ children, color, testId, }) => {
    return (jsxRuntime.jsx("svg", { width: "24px", height: "24px", viewBox: `0 0 ${gridSize} ${gridSize}`, className: styles$1.icon, "data-icon-color": color, "data-testid": testId, children: jsxRuntime.jsx("g", { transform: `rotate(0 ${gridSize / 2} ${gridSize / 2})`, children: children }) }));
};

const IconAlert = (props) => (jsxRuntime.jsx(IconContainer, Object.assign({}, props, { children: jsxRuntime.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", "data-icon-type": "fill", children: jsxRuntime.jsx("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M13.5,15 L10.5,15 L10.5,18 L13.5,18 L13.5,15 Z M13.5,6 L10.5,6 L10.5,13.5 L13.5,13.5 L13.5,6 Z" }) }) })));

const IconDanger = (props) => (jsxRuntime.jsx(IconContainer, Object.assign({}, props, { children: jsxRuntime.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", "data-icon-type": "fill", children: jsxRuntime.jsx("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M13.5,15 L10.5,15 L10.5,18 L13.5,18 L13.5,15 Z M13.5,6 L10.5,6 L10.5,13.5 L13.5,13.5 L13.5,6 Z" }) }) })));

const IconSuccess = (props) => (jsxRuntime.jsx(IconContainer, Object.assign({}, props, { children: jsxRuntime.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", "data-icon-type": "fill", children: jsxRuntime.jsx("path", { d: "M12,3 C16.9707,3 21,7.0293 21,12 C21,16.9707 16.9707,21 12,21 C7.0293,21 3,16.9707 3,12 C3,7.0293 7.0293,3 12,3 Z M15.7123106,8.65165043 L10.9393398,13.4246212 L8.2876894,10.7729708 L6.69669914,12.363961 L10.9393398,16.6066017 L17.3033009,10.2426407 L15.7123106,8.65165043 Z" }) }) })));

const IconTooltip = (props) => (jsxRuntime.jsx(IconContainer, Object.assign({}, props, { children: jsxRuntime.jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", "data-icon-type": "fill", children: jsxRuntime.jsx("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8ZM14 12V18H10V12H14Z" }) }) })));

const useNotificationStore = zustand.create(() => ({
    isPaused: false,
    notifications: [],
}));
const createNotification = (notificationVariant) => (options) => {
    // creating a notification at the same time as closing a dialog is a relatively common pattern,
    // but it can cause issues because the new notification would be placed inside a dialog that is getting removed in the same
    // render cycle.
    // To avoid this, we defer the creation of the notification to the next render cycle by pushing it to the end of the event loop.
    setTimeout(() => {
        const id = crypto.randomUUID();
        const notification = Object.assign(Object.assign({ isFirstMount: true, id, duration: DEFAULT_NOTIFICATION_DURATION_MS }, options), notificationVariant);
        useNotificationStore.setState((state) => ({
            notifications: [...state.notifications, notification],
        }));
    });
};
const actions = {
    clear: () => {
        useNotificationStore.setState({ notifications: [] });
    },
    dismiss: (notificationId) => {
        useNotificationStore.setState((state) => ({
            notifications: state.notifications.filter((notifications) => notifications.id !== notificationId),
        }));
    },
    info: createNotification({
        color: IconColor.Primary,
        icon: IconTooltip,
    }),
    success: createNotification({
        color: IconColor.Success,
        icon: IconSuccess,
    }),
    warning: createNotification({
        color: IconColor.Alert,
        icon: IconAlert,
    }),
    error: createNotification({
        color: IconColor.Danger,
        icon: IconDanger,
    }),
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

require("./_assets/Notification-CUdkmpPW.css");var styles = {"cardBody":"Notification__go2LBY_BWn__cardBody","moreMessages":"Notification__go2LBY_BWn__moreMessages","moreMessagesText":"Notification__go2LBY_BWn__moreMessagesText","moreMessagesTextContainer":"Notification__go2LBY_BWn__moreMessagesTextContainer","notificationBody":"Notification__go2LBY_BWn__notificationBody","notificationCard":"Notification__go2LBY_BWn__notificationCard","notificationContainer":"Notification__go2LBY_BWn__notificationContainer","notificationDescription":"Notification__go2LBY_BWn__notificationDescription","notificationDescriptionContainer":"Notification__go2LBY_BWn__notificationDescriptionContainer","notificationHeader":"Notification__go2LBY_BWn__notificationHeader","notificationIcon":"Notification__go2LBY_BWn__notificationIcon","notificationTitle":"Notification__go2LBY_BWn__notificationTitle","slideLeftEnter":"Notification__go2LBY_BWn__slideLeftEnter","slideLeftEnterActive":"Notification__go2LBY_BWn__slideLeftEnterActive","slideLeftExit":"Notification__go2LBY_BWn__slideLeftExit","slideLeftExitActive":"Notification__go2LBY_BWn__slideLeftExitActive"};

require("./_assets/fonts-CoIbUPG2.css");

const Notification = react.forwardRef(({ id, title, description, color, icon: Icon, duration, isFirstMount }, ref) => {
    const { isPaused } = useNotificationStore();
    react.useEffect(() => {
        if (!isPaused) {
            // notifications should dismiss themselves when they exceed their duration. However, since the same notification
            // might be remounted multiple times (e.g. when a dialog is opened/closed), we need to sync the remaining duration
            // back to the state on every unmount.
            const startTime = Date.now();
            const timeoutId = setTimeout(() => {
                actions.dismiss(id);
            }, duration);
            return () => {
                const timeElapsed = Date.now() - startTime;
                useNotificationStore.setState((state) => (Object.assign(Object.assign({}, state), { notifications: state.notifications.map((notification) => notification.id === id
                        ? Object.assign(Object.assign({}, notification), { duration: notification.duration - timeElapsed, isFirstMount: false }) : notification) })));
                clearTimeout(timeoutId);
            };
        }
    }, [id, duration, isPaused]);
    return (jsxRuntime.jsx("div", { className: styles.notificationCard, onClick: () => actions.dismiss(id), role: 
        // this notification node might get recreated when a dialog is opened/closed.
        // in such cases the notification should not be announced again
        isFirstMount ? 'alert' : undefined, "data-testid": "notification", ref: ref, children: jsxRuntime.jsxs("div", { className: styles.notificationBody, children: [jsxRuntime.jsxs("div", { className: styles.notificationHeader, children: [Icon && (jsxRuntime.jsx("div", { className: styles.notificationIcon, "aria-hidden": "true", "data-testid": "notification-icon", children: jsxRuntime.jsx(Icon, { color: color, testId: Icon.name }) })), jsxRuntime.jsx("p", { className: styles.notificationTitle, "data-testid": "notification-title", children: title })] }), jsxRuntime.jsx("div", { className: styles.notificationDescriptionContainer, children: jsxRuntime.jsx("p", { className: styles.notificationDescription, "data-testid": "notification-description", "data-a11y-ignore": "color-contrast" // This check is very flaky for this element, so disabling as contrant was manually verified
                        , children: description }) })] }) }));
});
Notification.displayName = 'Notification';

const AnimatedNotification = (_a) => {
    var { notification } = _a, props = __rest(_a, ["notification"]);
    const nodeRef = react.useRef(null);
    const animationClasses = {
        enter: styles.slideLeftEnter,
        enterActive: styles.slideLeftEnterActive,
        exit: styles.slideLeftExit,
        exitActive: styles.slideLeftExitActive,
    };
    return (jsxRuntime.jsx(reactTransitionGroup.CSSTransition, Object.assign({}, props, { classNames: animationClasses, timeout: { enter: ANIMATION_TIMEOUT, exit: ANIMATION_TIMEOUT }, nodeRef: nodeRef, children: jsxRuntime.jsx(Notification, Object.assign({ ref: nodeRef }, notification)) })));
};

const NotificationContainer = () => {
    const translator = translation.useTranslator();
    const { notifications } = useNotificationStore();
    const [root, setRoot] = react.useState(document.body);
    react.useEffect(() => {
        return () => {
            actions.clear();
        };
    }, []);
    const hiddenNotificationsCount = Math.max(0, notifications.length - MAX_NOTIFICATION_BEFORE_QUEUE);
    const visibleNotifications = notifications.slice(0, MAX_NOTIFICATION_BEFORE_QUEUE);
    react.useEffect(() => {
        const mutationObserver = new MutationObserver(() => {
            var _a;
            setRoot((_a = getTopmostDialog()) !== null && _a !== void 0 ? _a : document.body);
        });
        mutationObserver.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['open'],
        });
        return () => {
            mutationObserver.disconnect();
        };
    }, []);
    // dialogs are rendered in a top layer, which is displayed above all other elements
    // therefore we need to make sure to render the notifications in the
    // topmost dialog element directly
    return reactDom.createPortal(jsxRuntime.jsxs("div", { onMouseEnter: () => useNotificationStore.setState({ isPaused: true }), onMouseLeave: () => useNotificationStore.setState({ isPaused: false }), className: styles.notificationContainer, children: [jsxRuntime.jsx(reactTransitionGroup.TransitionGroup, { children: visibleNotifications.map((notification) => (jsxRuntime.jsx(AnimatedNotification, { notification: notification }, notification.id))) }), hiddenNotificationsCount > 0 && (jsxRuntime.jsx("div", { className: styles.moreMessages, "data-testid": "notification-more-messages", children: jsxRuntime.jsx("div", { className: styles.cardBody, children: jsxRuntime.jsx("div", { className: styles.moreMessagesTextContainer, children: jsxRuntime.jsx("span", { className: styles.moreMessagesText, children: translator.notificationsMoreMessages({
                                count: hiddenNotificationsCount,
                            }) }) }) }) }))] }), root);
};
const getTopmostDialog = () => {
    var _a;
    // querySelectorAll is much slower than getElementsByTagName and performance is important here
    // since this code will run frequently
    // eslint-disable-next-line unicorn/prefer-query-selector
    const dialogs = [...document.getElementsByTagName('dialog')].filter((dialog) => dialog.open);
    // the topmost dialog is the one that:
    // * is the deepest nested in other dialogs (has the most number of dialog ancestors)
    // * is last in the DOM order (if multiple dialogs have the same number of dialog ancestors)
    const dialogsWithDepth = dialogs.map((dialog) => {
        var _a, _b;
        let depth = 0;
        let parentDialog = (_a = dialog.parentElement) === null || _a === void 0 ? void 0 : _a.closest('dialog');
        while (parentDialog) {
            depth += 1;
            parentDialog = (_b = parentDialog.parentElement) === null || _b === void 0 ? void 0 : _b.closest('dialog');
        }
        return { dialog, depth };
    });
    const sortedDialogs = dialogsWithDepth.sort((a, b) => a.depth - b.depth);
    return (_a = sortedDialogs.at(-1)) === null || _a === void 0 ? void 0 : _a.dialog;
};

const NotificationService = {
    info: actions.info,
    success: actions.success,
    warning: actions.warning,
    error: actions.error,
};

exports.NotificationContainer = NotificationContainer;
exports.NotificationService = NotificationService;
//# sourceMappingURL=index.js.map
